import travelCertficateSuccessful from "components/TravelCertificate/travelCertficateSuccessful";

export const CONSTANT_ENGLISH_CONTENT: Record<string, string> = {
  welcome: "Welcome to Akasa",
  home: "Home",
  language: "अपनी भाषा चुनें",
  switchLang: "Switch Language",
  signIn: "Sign In",
  signInWithOTP: "Sign In With OTP",
  signInWithPassword: "Sign in with password",
  signInWithGoogle: "Sign in with Google",
  signInWithFacebook: "Sign in with Facebook",
  signUp: "Sign Up",
  invalidName: "Invalid Name",
  signUpBreezePast: "Sign-up to breeze past booking",
  otherSignInOptions: "Other sign in options",
  continueAsGuest: "Continue as guest",
  emailIdMobileNumber: "Email ID/Mobile Number",
  enterOTP: "Enter OTP",
  invalidPromoCodeText: "Invalid promo code",
  refundReceipt : "Refund Receipt",
  paymentType : "Payment Type",
  refundInitiatedDate: "Refund Initiated Date",
  otpSentTo: "OTP sent to",
  checkRefundStatus: "Check another refund status",
  confirmAndSignIn: "Confirm & Sign In",
  resendOTP: "Resend OTP",
  continueTxt: "Continue",
  password: "Password",
  forgotPassword: "Forgot Password",
  flown: "Flown",
  enterMobileOrEmailToReset:
    "Please enter your mobile number or email ID. We will send you an OTP to confirm your identity",
  sendOtp: "Send OTP",
  enterOtpSentTo: "Enter the OTP sent to",
  confirmOTP: "Confirm OTP",
  enterNewPassword: "Enter new password",
  makeSureYourPasswordHas: "Make sure your password has",
  eightChars: "8 characters",
  atLeast1UpperCase: "Atleast one uppercase letter",
  atLeast1LowerCase: "Atleast one Lowercase letter",
  atLeast1SpecialChar: "Atleast one Specials letter",
  atLeast1Num: "Atleast one number",
  enterAPassword: "Enter a Password",
  confirmPassword: "Confirm Password",
  passwordHaveAtLeast8Chars: "Make sure the password has at least 8 characters",
  passwordHaveAtLeast1Number: "Make sure the password has at least 1 number",
  passwordHaveAtLeast1Uppercase: "Make sure the password has at least 1 Uppercase letter",
  passwordsDidNotMatch: "Passwords did not match",
  setPasswordAndLogin: "Set Password & Login",
  signUpForAPersonalisedExperience: "Sign up for a personalised experience",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  gender: "Gender",
  selectGender: "Select gender",
  genderMale: "Male",
  genderFemale: "Female",
  genderOther: "Other",
  genderPreferNotToShare: "Prefer not to share",
  dob: "Date of birth",
  selectFare: "Select Fare",
  specialOfferForDob: "Enjoy special offers on your birthday month",
  country: "Country",
  india: "India",
  emailId: "Email ID",
  altEmailId: "Alt Email ID",
  phone: "Mobile Number",
  faceIdForFasterSignIn: "Use face ID for faster sign-in",
  submit: "Submit",
  completeYourSignUp: "Complete your sign up",
  usePwdInstead: "Use password instead",
  letsSecureYourAccount: "Lets secure your account",
  useOtpInstead: "Use OTP instead",
  homeAppBar: "Home",
  bookAppBar: "Book",
  meAppBar: "Me",
  moreAppBar: "More",
  travelGuideline: "Check the latest travel guidelines",
  joinClubAkasa: "Join Club Akasa",
  searchWidgetTitle: "Book a Flight",
  searchWidgetStrip: "Get 10% OFF on your first trip",
  searchWidgetStripLoggedIn: "Book your return flight to Bengaluru",
  checkInAccessButton: "Check-in",
  flightStatusAccessButton: "Flight Status",
  myBookingsAccessButton: "My Bookings",
  nudgeWidgetTitle: "Sign in for a personalised experience",
  nudgeWidgetTitleLoggedIn: "Earn points on every booking with Club Akasa",
  nudgeWidgetButtonText: "Sign up now",
  nudgeWidgetButtonTextLoggedIn: "Join the club",
  exploreWidgetButtonText: "View all",
  exploreWidgetTitle: "Not sure where to go? Explore",
  recentSearchesTitleText: "Your recent searches",
  addBirthDateTitleText: "Celebrate your special day with us",
  addBirthDateSubTitleText: "Enjoy special offers on your birthday month",
  addBirthDateButtonText: "Add birthdate",
  noBlank: "Cannot be blank",
  emailPhoneNoBlank: "Email/Phone cannot be blank",
  invalidUser: "Invalid user",
  invalidEmailPhone: "Invalid email or phone number",
  invalidEmail: "Invalid email",
  invalidPhone: "Invalid phone number",
  canContainOnlyAlphabets: "Can contain only alphabets",
  invalidOtp: "Invalid OTP",
  maxLen: "Max {} characters allowed",
  minLen: "Should have at least {} characters",
  charsAllowed: "Only letters are allowed",
  charsAndSpaceAllowed: "Only letters and single space are allowed",
  numNotAllowed: "Numbers not allowed",
  specialCharsNotAllowed: "Special characters not allowed",
  bookAgainWidgetTitleText: "Book again",
  bookAgainButtonText: "Book",
  rateYourTripText: "Rate your trip",
  closeText: "Close",
  closed:"Closed",
  excessBaggage: "Excess Baggage",
  extraBaggage: "Additional Bags",
  musicKit: "Sport/Music Equipment",
  bookACab: "Book a cab to the airport",
  manageBookingButtonText: "Manage Booking",
  manageBooking: "Manage Booking",
  addMoreToBookingText: "Add more to your BLR-DEL booking",
  tripCompletedText: "Trip Completed",
  refineResults: "Refine Results",
  priceRange: "Price range",
  trackRefundStatus: "Enter your PNR/Booking Reference number, email ID/last name, to track your refund status",
  paymentStatus: "Payment Status",
  refundStatus: "Refund Status",
  totalRefundAmount: "Total Refund Amount",
  refundSummary: "Refund Summary",
  refundSummaryDescription: "Refund amount will be credited to the original payment method.",
  checkAnotherRefundStatus: "Check another refund status",
  initiatedByCustomer: "Initiated by Customer",
  refundInitiateMsg: "Refund has been initiated by the customer",
  processing: "Processing",
  refundProcessingMsg: "The refund is being processed by Akasa Air",
  withBank: "With Bank",
  refundBankMsg: "The refund amount is pending with your bank. Usually it takes 5-7 days for banks to process the refund. Please contact the bank for more details.",
  refundCompleted: "Refund Completed",
  refundCompletedMsg: "The refund has been completed.",
  refundRnnMsg: "The RNN number is {}.",
  processed: "Processed",
  refundInitiatedOn: "Refund Initiated on",
  refundCancelErrorMsg: "Booking is not cancelled",
  groupPNR: "Group PNR",
  trackRefundStatusTitle: "Track Refund Status",
  groupBooking: "Group Booking",
  completed: "Completed",
  groupBookingRefundStatusMsg:"You have retrieved a group PNR",
  bookingNotCancelled: "Current booking is not cancelled",
  numberOfStops: "Number of stops",
  buttonLiteralSelect: "Select",
  literalLeft: "left",
  literalTo: "to",
  complimentaryMeal: "Complimentary Meal",
  bookYourFlight: "Book your flight",
  addPromoCode: "Add Promo Code",
  apply: "Apply",
  complimentarySeat: "Complimentary seat",
  complimentarydateChange: "Complimentary Date Change",
  cancellationFee: "Low cancellation fee",
  upgradetoFlexiTitle: "Select our Flexi Fare for just {} more and enjoy benefits worth up to ₹3,500!",
  stops: {
    zero: "Non Stop",
    one: "1 Stop",
    two: "{} Stops",
    few: "{} Stops",
    many: "{} Stops",
    other: "{} Stops"
  },
  yrs: {
    zero: "{} yr",
    one: "{} yr",
    two: "{} yrs",
    few: "{} yrs",
    many: "{} yrs",
    other: "{} yrs"
  },
  stopsLowercase: {
    zero: "Nonstop",
    one: "1 stop",
    two: "2 stops",
    many: "{} stops",
    other: "{} stops"
  },
  daysToGoPlural: {
    zero: "0 day to go",
    one: "1 day to go",
    two: "2 days to go",
    many: "{} days to go",
    other: "{} days to go"
  },
  passengersPlural: {
    zero: "No Passenger",
    one: "1 Passenger",
    two: "2 Passengers",
    many: "{} Passengers",
    other: "{} Passengers"
  },
  earnPoints: {
    zero: "No points available",
    one: "Earn 1 point",
    many: "Earn {} points",
    other: "Earn {} points"
  },
  seats: {
    zero: "No seat",
    one: "1 seat",
    many: "{} seats",
    other: "{} seats"
  },
  adultPlural: {
    zero: "No Adult",
    one: "1 Adult",
    two: "2 Adults",
    many: "{} Adults",
    other: "{} Adults"
  },
  seniorCitizenPlural: {
    zero: "No Senior Citizen",
    one: "1 Senior Citizen",
    two: "2 Senior Citizens",
    many: "{} Senior Citizens",
    other: "{} Senior Citizens"
  },
  childrenPlural: {
    zero: "No Child",
    one: "1 Child",
    two: "2 Children",
    many: "{} Children",
    other: "{} Children"
  },
  infantPlural: {
    zero: "No Infant",
    one: "1 Infant",
    two: "2 Infants",
    many: "{} Infants",
    other: "{} Infants"
  },
  pointsPlural: {
    zero: "No points",
    one: "1 point",
    many: "{} points",
    other: "{} points"
  },
  left: "left",
  lowestFairOnOtherAirline: "Lowest fair available on other airline is",
  fastestFlight: "Fastest flight",
  lowestFare: "Lowest fare",
  earliestFlight: "Earliest flight",
  departureTime: "Departure time",
  earlyMorning: "Early Morning",
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
  night: "Night",
  switchCurrency: "Switch currency",
  sortBy: "Sort by",
  price: "Price",
  duration: "Duration",
  apply: "Apply",
  passengers: "Passenger(s)",
  passenger: "Passenger",
  extraSeat: "Extra Seat",
  extraSeats: "Extra Seat(s)",
  done: "Done",
  bookAFlight: "Book a flight",
  myBookings: "My Bookings",
  searchWithVoice: "Search with voice",
  oneWay: "One Way",
  roundTrip: "Round Trip",
  multiCity: "Multicity",
  invalidTrip: "Invalid trip type",
  from: "From",
  to: "To",
  cityOrAirport: "City/Airport",
  departureDate: "Departure date",
  arrivalDate: "Arrival date",
  returnDate: "Return date",
  adult: {
    zero: "0 Adult",
    one: "1 Adult",
    other: "{} Adults"
  },
  specialFares: "Special fares",
  armedForces: "Armed Forces",
  doctorsNurses: "Doctors & Nurses",
  seniorCitizens: "Senior Citizens",
  students: "Students",
  promoCode: "Promo Code",
  PromotionDiscount: "Promo code applied",
  Discount: "Discount",
  promoTextPart1: "Use code",
  promoTextPart2: "to get {}% off {}",
  onFirstTrip: "on your first trip",
  searchFlights: "Search Flights",
  flying: "Flying {}",
  searchFor: "Search For {}",
  recentStationSearches: "Recent Searches",
  currentLocation: "Use current location",
  popularCities: "Popular cities",
  airportNearestTo: "Airport nearest to {}",
  kmsFrom: {
    one: "{} km from {}",
    other: "{} kms from {}"
  },
  saveOnReturns: "Save 10% on roundtrips",
  travelDates: "Travel Dates",
  favouriteFlights: "Favourite flights",
  whosTravelling: "Who’s travelling?",
  nameAccordingToGovtId: "Name should be as per Aadhaar/Passport or any other Government ID",
  addDetails: "Add details",
  editDetails: "Edit details",
  primaryContactDetails: "Primary contact details",
  allBookingRelatedInfoWillBeSentHere: "All booking related info will be sent here",
  optionalEmergencyContactDetails: "Emergency contact details (Optional)",
  addGSTDetails: "Add GST details",
  thisIsaBusinessTrip: "This is a business trip",
  sendBookingToBusinessEmail: "A copy of booking related info will be sent to your work inbox",
  viewSummary: "View summary",
  optionalText: "Optional",
  imTravelling: "I'm travelling",
  requiresSpecialAssistance: "Requires special assistance",
  travelDetails: "Add travel document details",
  saveCapitalisedText: "Save",
  flightDetailsText: "Flight Details",
  baggageAllowance: "Baggage Allowance",
  flightDuration: "Flight duration",
  notifyMeWhenPriceDrops: "Notify me when price drops",
  cabin: "Cabin",
  checkIn: "Check-in",
  wifi: "Wifi",
  plugPoints: "Plug Points",
  seatsTitle: "Select seats",
  skip: "Skip",
  selectSeat: "Select Seat",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  exit: "Exit",
  confirmSeats: "Confirm Seats",
  windowSeat: "Window Seat",
  adjacentSeat: "Adjacent seat",
  entireRow: "Entire row",
  iAccept: "i accept",
  termsNConditions: "terms and conditions",
  forExtraSeats: "for extra seats",
  adultPassengerType: "Adult",
  childPassengerType: "Child",
  infantPassengerType: "Infant",
  seniorCitizenPassengerType: "Senior Citizen",
  unaccompaniedMinorPassengerType: "Unaccompanied Minor",
  firstNameErrorText: "Please enter first name",
  lastNameErrorText: "Please enter last name",
  genderErrorText: "Please select gender",
  dobErrorText: "Please enter Date of Birth",
  addOnNudgeTitle: "Customise your booking?",
  addOnNudgeSubtitle: "Pick your seats, pre-order meals, booking excess baggage and much more",
  goToAddOns: "Yes, Go to Add-ons",
  skipToPayment: "No, Skip to payments",
  mobilityAssistance: "Mobility",
  impairmentsAssistance: "Impairments",
  addDescriptionText: "Add Description",
  selectOptionErrorText: "Please select an option",
  addDescriptionErrorText: "Please add a description",
  gstNumber: "GST Number",
  registeredCompanyName: "Company Name",
  registeredEmailAddress: "Company Email Address",
  add: "Add",
  gstNumberErrorText: "Invalid GST Number",
  saveToProfile: "Save to profile",
  enterGstErrorText: "Please enter GST Number",
  enterRegisteredCompanyNameErrorText: "Please enter registered company name",
  enterRegisteredEmailAddressErrorText: "Please enter registered email address",
  yesterday: "Yesterday",
  today: "Today",
  tomorrow: "Tomorrow",
  dayAfterTomorrow: "Day After Tomorrow",
  noFlightsFound: "No flights found",
  back: "Back",
  pnr: "PNR",
  cities: "Cities",
  flightNumber: "Flight Number",
  or: "OR",
  pnrTextField: "PNR/Booking Ref",
  myUpcomingFlights: "My Upcoming Flights ({})",
  allow: "Allow",
  deny: "Deny",
  enableAccessibilityMode: "Enable accessibility mode",
  signUpForFasterCheckout: "Sign up for faster checkout",
  otpMsg: "is your Akasa Air OTP. Do not share it with anyone",
  otpDescription: "Allow Akasa Air to read the message below and enter code?",
  shareFlightStatus: "Share flight status",
  share: "Share",
  addToFavourites: "Add to Favourites",
  addToCalender: "Add to Calendar",
  "viewETicket  ": "View E-ticket",
  gotSpecialCode: "Got a special code? Add it here for discounts",
  carouselBookNow: "Book Now",
  bannerLogin: "Login",
  enterMobileNumberErrorText: "Please enter mobile number",
  enterEmailErrorText: "Please enter email address",
  clear: "Clear",
  foundFlights: "Found {} flights",
  paxLiteral: "Pax",
  clearLiteral: "Clear",
  savedTravellers: "Saved travellers",
  addAndContinue: "Add & Continue",
  pleaseSpecify: "Please specify",
  editGSTDetails: "Edit GST Details",
  gstDetailsAddedFor: "Details added for",
  savedCompanies: "Saved companies",
  trackFlightPrices: "Track flight prices",
  noStations: "No Stations found",
  hideFares: "Hide fares",
  arrivalDateBeforeDepartureErrorText: "Arrival date should be after departure date",
  somethingWentWrong: "Something went wrong please try again later",
  returnTxt: "Return",
  onwardTxt: "Onward",
  myBookingUpcomingText: "Upcoming",
  myBookingPastText: "Past",
  bookingSummary: "Booking summary",
  fareSummary: "Fare summary",
  myBookingPNRNoText: "PNR No.",
  myBookingPopupOptionsCheckin: "Check in",
  myBookingPopupOptionsChangeBooking: "Change booking",
  myBookingPopupOptionsCancelBooking: "Cancel booking",
  myBookingPopupOptionsCancelFlightBooking: "Cancel flight",
  retrieveABookingTxt: "Retrieve A Booking",
  addOns: "Add-ons",
  valueCombos: "Value combos",
  mostPopular: "Most Popular",
  akasaPremium: "Akasa Premium",
  akasaPremiumContent: "Get a premium seat, meal, priority check-in and more",
  akasaValue: "Akasa Value",
  akasaValueContent: "Get a premium seat and complimentary meal",
  pickYourAddOns: "Pick your add-ons",
  included: "Included",
  edit: "Edit",
  selectSeats: "Select Seats",
  razorPayDescription: "Pay using Razorpay",
  razorPayName: "Akasa trip Booking",
  flightSummaryOneWayTitle: "Your one way flight summary for ",
  flightSummaryRoundTripTitle: "Your round trip flight summary for ",
  flightSummaryMultiCityTitle: "Your multicity flight summary ",
  travelGuidelineWithCityCodes: "Check the latest travel guidelines for ",
  earn150Points: "Earn 150 points on this trip",
  earn150PointsDesc: "You’re one step away from earning Earn 150 points on this trip with Club Akasa",
  gstDetails: "GST details",
  copyOfYourBookingRelated: "A copy of your booking related info will be sent to ",
  GetUpdatesOnWhatsapp: "Get updates on Whatsapp",
  bookingRelatedUpdatesWhatsapp: "All your booking related updates will be sent to your number ",
  onWhatsapp: " on Whatsapp",
  cancellationDateChangeCharges: "Cancellation & date change charges",
  productDocument: "Product Document",
  chooseDateOfBirth: "Choose Date Of Birth",
  makePayment: "Make Payment",
  selectMeals: "Select meals",
  mealsSelected: "Meals selected",
  searchForMeals: "Search For Meals",
  noMeals: "No Meals Found. Try a different meal",
  onlyVeg: "Only veg",
  allForAllPassengers: "Add for all\npassengers",
  allAddOns: "All add-ons",
  fareBreakdown: "Fare breakdown",
  extras: "Extras",
  conditionsBeforeYouFly: "Conditions before you fly",
  iHaveAllTheNecessaryTravelDocumentsNeededForThisItineraryAndIUnderstand:
    "I have all the necessary travel documents needed for this itinerary and i understand",
  iMustWearAFaceMaskForTheDurationOfTheFlightInAccordanceWithAkasaProtocolsForTheSafetyOfAllPassengers:
    "I must wear a face mask for the duration of the flight in accordance with Akasa protocols for the safety of all passengers",
  iDonotHaveAnyProhibitedItemsInMyBaggage: "I Don’t have any prohibited items in my \u2028baggage",
  taxesAndFees: "Taxes & fees",
  removeAll: "Remove All",
  allPassengers: "All passengers",
  yourUpcomingFlights: "Your upcoming flights",
  noAnnualFees: "No annual fees",
  earnPointsWithEveryBooking: "Earn points with every booking",
  spendPointsAtOurRetailPartners: "Spend points at our retail partners",
  selectAddOns: "Select Add-ons",
  skipAddOns: "Skip Add-ons",
  checkInThroughAutoAssignedSeats: "Check in through auto assigned seats",
  hopOnboard: "Hop Onboard",
  youHaveSuccessfullySelected: "You have successfully selected your {}!",
  healthAndContactDeclaration: "Health & Contact Declaration",
  allFieldsAreMandatory: "All fields are mandatory",
  selectSameAddressForAll: "Select same address for all",
  destinationAddress: "Destination Address",
  destinationPincode: "Destination Pincode",
  iAmNotResidingInNayContainmentZone: "I am not residing in nay containment Zone",
  iAmNotSufferingFromAnyFeverCoughOrAnyRespiratoryDistress:
    "I am not suffering from any fever, cough or any respiratory distress",
  iAmNotUnderQuarantine: "I am not under quarantine",
  iHaveNotTestedCOVID19PositiveInTheLastThreeWeeks: "I have not tested COVID-19 positive in the last three weeks",
  iAmEligibleToTravelAsPerTheExtantNorms: "I am eligible to travel as per the extant norms",
  iWillAdhereToTheHealthProtocalPrescribedByTheDestinationStateUnionTerritory:
    "I will adhere to the health protocal prescribed by the destination state/union territory",
  age: "Age",
  iDeclareThat: "I declare that",
  onlineCheckInOpens48HoursPriorToDepartureAFacilitationFeeOf200IsApplicableForAirportCheckInWithAssistance:
    "Online Check-in opens 48 hours prior to \ndeparture A facilitation fee of ₹200 is applicable for airport check-in with assistance",
  addMore: "Add More",
  eTickets: "E- Tickets",
  boardingPass: "Boarding Pass",
  updateDetails: "Update Details",
  allJourneys: "All Journeys",
  selectAll: "Select all",
  viewBooking: "View booking",
  pnrOrBookingReference: "PNR/Booking Reference",
  emailOrLastName: "Email/Last Name",
  retrieveYourBookingUsingPNR: "Retrieve your booking using PNR",
  tAndC: "T&C",
  poweredBy: "Powered by",
  upcomingTrip: "Upcoming Trip",
  quickRebook: "Quick rebook",
  bookAgain: "Book Again",
  dangerousGoodsAndRestrictedArticles: "Dangerous goods & restricted articles",
  doNotCarryDangerousGoodsInYourBaggageOrOnYourPerson: "Do not carry dangerous goods in your baggage or on your person",
  iHaveReadAndUnderstoodAllTheUnderstandAllTheImportantSecurityInformation:
    "I have read and understood all the understand all the important security information",
  cannotProceedFurther: "Cannot proceed further",
  webcheckIinIsNotPossibleForThisBookingPleaseCompleteYourCheckInFormalitiesAtTheAirportWhereWeCanAssistYouBetter:
    "Web check-in is not possible for this booking. Please complete your check-in formalities at the airport where we can assist you better",
  iWantToReadTheConditions: "I want to read the conditions",
  returnToHome: "Return to home",
  notAvailable: "Not Available",
  passengerDetails: "Passenger details",
  paymentSummary: "Payment summary",
  baggageCheckIn: "Baggage Check-in",
  shareItinerary: "Share itinerary",
  chat: "Chat",
  callUs: "Call us",
  faq: "FAQ's",
  newMoreHelp: "New More help ?",
  modifyBooking: "Modify Booking",
  viewCancellationPolicy: "View cancellation policy",
  updateContactDetails: "Update contact details",
  updateHealthDetails: "Update health details",
  specialRequests: "Special requests",
  changeBooking: "Change booking",
  changeDates: "Change Dates",
  retrieveWithoutPNR: "Retrieve without a PNR",
  retrieveUsingAPNR: "Retrieve using a PNR",
  retrieveYourBookingWithoutPNRUsingDetailsBelow: "Retrieve your booking without a PNR using the details below",
  baggageInformation: "Baggage information",
  handBaggage: "Hand Baggage",
  checkinBaggage: "Check-in Baggage",
  trackBaggage: "Track baggage",
  businessProfile: "Business profile",
  businessProfileDesc: "Keep your work trips separate from your business trips",
  addNewProfile: "Add New Profile",
  noDocumentsAdded: "No documents added",
  myDocumentsDesc: "Keep your important documents handy by storing them in our secure vault",
  addDocument: "Add Document",
  myDocuments: "My documents",
  myPreferences: "My preferences",
  noTravelersAdded: "No travellers added",
  savedTravelersDesc: "Add people to your list of saved travellers to quickly add them when you book your next flight",
  savedTravelers: "Saved travellers",
  addTraveler: "Add Traveller",
  followUsOnSocialMedia: "Follow us on social media",
  needHelp: "Need Help?",
  savedPayments: "Saved Payments",
  logout: "Logout",
  offersForYou: "Offers for you",
  rateNow: "Rate now",
  rateNowDesc: "Loving the experience? Rate us on the app store",
  shareReferralLink: "Share referral link",
  referAndEarn: "Refer and Earn",
  changePassword: "Change password",
  editProfile: "Edit profile",
  exploreMembership: "Explore membership",
  cancel: "Cancel",
  validOnlyCancelledBooking: "Valid only for Cancelled Booking",
  cancelStatus: "Closed",
  cancelledAmount: "Cancellation Amount",
  removeThisTraveller: "Remove this traveller?",
  no: "No",
  yes: "Yes",
  update: "Update",
  relationship: "Relationship",
  removeTraveller: "Remove traveller",
  saving: "Saving",
  editTraveller: "Edit traveller",
  createTraveller: "Create traveller",
  dateOfBirthOptional: "Date Of Birth (Optional)",
  passengerNumber: "Passenger {}",
  currency: "Currency",
  currencies: "Currencies",
  noCurrenciesFound: "No currencies found",
  upcomingFlight: "upcoming fight",
  modifybooking: "Modify booking",
  preferredDate: "Preferred date",
  cancelBooking: "Cancel Booking",
  sendBoardingPass: "Send Boarding Pass",
  emailID: "Email ID",
  sendToAnotherId: "Send to another ID",

  sendBoardingPassId: "Send all boarding passes to this ID",
  boardingPassMailedDesc: "Your boarding passes will be mailed to the below email IDs",
  dayToGo: "days to go",
  confirmBooking: "Fare locked. Confirm your booking",
  exitSeatsTitle: "Exit/emergency row seats",
  flightDelayCover: "Flight delay cover",
  noFlightDelayCoverAvailable: "No flight delay cover available",
  agreeToPurchaseAddon:
    "I agree to purchase {}. I have read the product document and agree to the terms and conditions.",
  yourXBookingForYisSuccessful: "Your {} booking for {} is successful",
  yourMultiCityBookingIsSuccessful: "Your multicity booking is successful",
  unableToLoadThisAddOn: "Unable to load this add on at this moment",
  specialRequest: "Special request",
  cancelBookingMsg: "Are you sure you want to cancel the \nbooking?",
  deleteUserConfirmationMsg: "Are you sure?",
  deleteUserContentMsg: "Deleting the user will delete all the data associated with the account, and it is not reversible",
  bookingConfirmedAndPnr: "Booking confirmed • PNR {}",
  bookingCancelled: "Booking cancelled",
  noBookingFound: "No booking found",
  autoAssignSeatsFailed: "Auto assign seats failed",
  checkInFailed: "Check in failed",
  stationCodeIsRequired: "Station code is required",
  tryADifferentRoute: "Try a different date",
  yourFareIsLocked: "Your fare is locked",
  confirmYourBooking: "Confirm your booking",
  lockFare: "Lock fare",
  infantDisclaimerText: "Infants will be seated on lap. They wont be assigned a separate seat.",
  reset: "Reset",
  resetBooking: "Reset booking?",
  resetBookingDisclaimer: "Are you sure you want to reset current information and start afresh?",
  pay: "Pay",
  youPay: "You Pay",
  youPaid: "You Paid",
  downloadInvoice: "Download Invoice",
  promoCodeApplied: "Promo code applied",
  seatsTotal: "Seats Total",
  convFeeTooltip: "A non-refundable convenience fee of {} will be applied per trip",
  ifThePriceIncreasesYouStillPay: "If the price increases you still pay ",
  until: "until",
  lockFareFor: "Lock fare for ",
  fareLockPriceNudge: "Please pay the fare amount of {} before {} by {} to confirm your booking",
  fareLockShortNudge: "Lock fare for {} until {} ",
  fareLockDesc: "If the price increases you still pay {}.",
  autoAssignSeats: "Auto assign seats",
  boardingTime: "Boarding time",
  zone: "Zone",
  flight: "Flight",
  sequenceNo: "Sequence no.",
  membershipNo: "Membership no.",
  seat: "Seat",
  gate: "Gate",
  checkInForCityCodes: "Check-in for {}",
  enhanceYourBooking: "Enhance your booking",
  boardingPasses: "Boarding passes",
  checkInSuccessful: "Check-in successful!",
  enjoyYorFlight: "Enjoy your flight!",
  Paid: "Paid",
  checkInNotAllowed: "Check in not allowed",
  disagree: "I Disagree",
  agree: "I Agree",
  yourFlightForCityCodes: "Your flight for {}",
  email: "Email",
  download: "Download",
  upcoming: "UpComming",
  past: "Past",
  advertisement: "Advertisement",
  cafeAkasaMenu: "Cafe Akasa menu",
  pointsToRemember: "Points to remeber",
  bookFlightRetrieveTxt: "Book flights to see them here or retrieve",
  anExistingBooking: "an existing booking",
  departureTerminal: "Departure Terminal",
  boardingZone: "Boarding Zone",
  date: "Date",
  departure: "Departure",
  services: "Services",
  seq: "Seq",
  akasaURL: "akasaair.com",
  gateSubject: "Gate is subject to change and will close",
  minutesOfDeparture: "25 minutes prior to depature",
  akasaMobileOffer: " Book on AkasaAir.com or our mobile app for special deals and offers",
  Tax: "Tax",
  bookingStatus: "Booking status",
  bookingDetails: "BOOKING DETAILS",
  bookingReference: "Booking Reference/PNR",
  dateOfBooking: "Date of Booking",
  paymentStatus: "Payment Status",
  flightDetails: "FLIGHT DETAILS",
  stopsCount: "Stops",
  departs: "Departs",
  arrives: "Arrives",
  baggage: "Baggage",
  checkInWarning: "Check-in counters close strictly 60 minutes prior to departure.",
  bookATest: "Book a Test",
  uberOnAirport: "Take an Uber to the airport",
  bookInAdvanceTxt: " Book in advance to avoid surge prices",
  AirSewa: "AirSewa",
  tipsTitle: " Make your travel hassle free with these tips",
  snvAviation: "SNV Aviation Private Limited",
  corporateOffice: "Corporate Office",
  coperateAddress: "12th Floor, Urmi Estate, 95, Ganpatrao Kadam Marg, Lower Parel (West), Mumbai 400013.",
  telephoneNumberTxt: "Telephone Number ",
  telephoneNumber: " 022 0987 0987",
  helplineNumberTxt: "Helpline number ",
  helplineNumber: " 1800 123 456",
  visit: "Visit",
  writetous: "Write to us",
  infomail: "info@akasaair.com",
  noticeForDangerousGoodsTXT: "Notice for dangerous goods & restricted articles",
  noticeForDangerousGoodsSubTitle: "Do not carry dangerous goods in your baggage or on your person",
  flightsOverlappingTxt: "Flights are overrlapping please select another flight",
  selectBothFlights: "Please select both onward and return flights",
  selectCta: "Select",
  seatsAtthisPrice: "seats left at this price",
  eightpmTwelveam: "20:00-24:00",
  fourpmEightpm: "16:00-20:00",
  twelvepmFourpm: "12:00-16:00",
  sixamTwelvepm: "6:00-12:00",
  twelveamSixam: "12:00-6:00",
  modify: "modify",
  updateContactDetailsinProfile: "Update contact details in my profile. This will replace your existing details",
  setupbusinessAccounttoRecieveCopy:
    "Set up a business account to receive a copy of your booking related info to an official account",
  ChangeProfile: "Change Profile",
  validphotoID: "Valid photo ID must be present at check in.",
  changeRequest: "change request",
  noFlightDetailsFound: "No Flight Details Found",
  selectAddonsStepper: "Select Add-ons",
  seatSelectionStepper: "Seat Selection",
  seatSelected: "seat selected",
  bookingSuccessful: "booking is successful",
  shareIternary: "Share Iternary",
  PassengerName: "Passenger Name",
  nonStop: "Non-Stop",
  stopOverAt: "Stopover at",
  seatAvailable: "Non-reclining",
  seatOccupied: "Occupied",
  seatPremium: "Premium",
  paymentHeading: "Akasa Air",
  paymentDescription: "Pay using Razorpay",
  convenienceFeeAmount: "350",
  showViewSummaryOnFlightSearchPage: "true",
  seatSelectionErrorText: "Please select Seat",
  preBookMealLimitForTime: "Note : Meals can be pre-booked up to 12 hrs prior to flight departure",
  boardingPassesAutoAssignCheckInTitle: "Keep an eye out for boarding passes",
  youAreRestrictedTowebcheckin: "You are restricted to web check-in",
  addOnsSuccessfullyAddedToYourBooking: "Add on(s) successfully added to your booking",
  seatsSuccessfullyAddedToYourBooking: "Seat(s) successfully added to your booking",
  addOnsAndSeatsSuccessfullyAddedToYourBooking: "Add on(s) and seats successfully added to your booking",
  addedMoreToYourBooking: "Added more to your booking",
  seatFee: "Seat Fee",
  deBoardingNotAllowed: "Deboarding aircraft may not be allowed",
  changeOfAircraft: "change of aircraft",
  Connect: "Connecting",
  Through: "Through",
  paymentFailedTryAgain: "Payment Failed, please try again..",
  allMeals: "All Meals",
  paymentFailedDesc: "Looks like your payment did not go through.",
  bookingOnHoldAndPnr: "Your PNR-{} is this",
  onHold: "ON-HOLD",
  paymentResolutionAssurance: "Please be assured that - Either you will recieve a confirmed PNR within 15 minutes",
  moneyWillBeRefundedMessage: "Your money will be refunded",
  contactCustomerSupportMessage: "You could contact customer support for more information",
  currentODIsNotActive: "We are Currently not active for the search origin and destination",
  checkFlightStatus: "Check Flight Status",
  noUpcomingFlightsFound: "Currently we’re unable to locate your upcoming flight.",
  noUpcomingFlightsFoundDescriptionMessage:
    "Kindly visit the Manage Booking section to retrieve your active booking and add it to your profile.",
  non3DCardMsg: "Please note that we do not accept non-3D Secure International Credit Cards",
  extraSeatErrorTitle: "Extra Seat",
  extraSeatErrorMsg:
    "Since you have opted for Extra Seat, you must select seats which are available next to each other.",
  groupBookingCheckInErrMsg:
    " Your reservation has been created as a group booking by your travel agent which includes multiple passengers. To ensure privacy, we are unable to display the booking. Please check-in at our airport counter.",
  groupBookingManageBookingErrMsg:
    " Your reservation has been created as a group booking by your travel agent which includes multiple passengers. To ensure privacy, we are unable to display the booking. Please contact your travel agent for any changes to your booking.",
  userOfflineHeadingText: "Looks like you’re offline.",
  userOfflineContentText: "Try switching your internet connection.",
  toggleExtraSeatError: "Please select Extra Seat",
  extraSeatChangeBookingMsg: ". Change Booking facility is not applicable for booking which include `Extra Seat`",
  applied: "Applied",
  terminalChange: "Terminal change from {} to {}",
  internationalVerifyDocumentsMessage: "Please verify your travel documents at our airport check-in counter and collect your boarding pass.",
  internationalCheckInSuccessDescription: "You have successfully checked-in for your flight. Please verify your travel documents at our airport check-in counter and collect your boarding pass.",
  internationalAutoSeatCheckInSuccessDescription: "Thank you for selecting the Auto Seat Select option. Your seat number will be assigned to you six hours before flight departure. You will need to verify your travel documents at our airport check-in counter and collect your boarding pass.",
  groupBookingImportantNote: "<div style='color: #666666; text-align: left; font-weight:400'><b>Important note</b>: Your reservation is under a ‘group booking’ and may have been made by your travel agent. Hence, it may reflect additional passenger names not associated with you. Please contact your travel agent for any additional queries.</div>",
  noFlightFoundToMatchYourFilters: "No flights found to match your filters",
  pleaseResetYourFiltersToSeeFlights: "Please reset your filters to see flights",
  resetFilters: "Reset Filters",
  notApplicablePromoCode: "Apply",
  conditionsOfCarriageUrl:"/quick-links/conditions-of-carriage",
  privacyPolicyUrl:"/quick-links/privacy-policy",
  termsAndConditionsUrl:"/quick-links/terms-and-conditions",
  iAgreeToTermsAndPolicy: "<div style='color: #333333; text-align: left; font-weight:400'>I agree with the applicable <a style='color: #5C0FD9; text-decoration: none; font-weight:700' href='{cocLink}'> Conditions of Carriage</a> (as available on the Website), <a style='color: #5C0FD9; text-decoration: none; font-weight:700' href='{privacyPolicyLink}'>Privacy Policy </a> and <a style='color: #5C0FD9; text-decoration: none; font-weight:700' href='{tncLink}'> Terms and Conditions</a></div>",
  etihadCheckInInfo: "<div>You are trying to check-in for an Etihad Airways codeshare flight. Please contact <a style='color: #5C0FD9; text-decoration: none; font-weight:700' href='https://www.etihad.com/'> Etihad Airways</a> or visit the airport counter to complete your check-in.</div>",
  etihadManageBookingInfo: "<div>You are trying to check-in for an Etihad Airways codeshare flight. Please contact <a style='color: #5C0FD9; text-decoration: none; font-weight:700' href='https://www.etihad.com/'> Etihad Airways</a> or visit the airport counter to complete your manage.</div>",
  codeShareCheckInMsg: "<div>Passengers on Etihad Airways codeshare flights can check-in only at the airport check-in counter. Please contact <a href='https://www.etihad.com/en-in/'>Etihad Airways</a> for further assistance.</div>",
  duplicatePaxErrorMsg:"The passenger details you entered are already present above",
  travelDocumentAirportCheckIn:"Please verify your travel documents at our airport check-in counter and collect your boarding pass.",
  allowedUploadFileTypes: '[ "application/msword" , "application/vnd.openxmlformats-officedocument.wordprocessingml.document" , "application/pdf" , "image/jpeg" , "image/png" ]',
  noUpcomingBooking: "Sorry! You don’t seem to have any upcoming booking. Plan your next travel with us!",
  noPastBooking: "Sorry! You don’t seem to have any past booking. Plan your next travel with us!",
  generateCertificateOrRetrieveAnExistingOne: "Generate certificate or retrieve an existing one",
  travelCertificate: "Travel certificate",
  generatedOn: "Generated on",
  travelCertficateInfoMsg : "You can download your travel certificates at any time from the <strong>Travel certificates</strong> section once they have been generated",
  yourTravelCertficateInfoMsg : "Your travel certificates are ready to be downloaded",
  generateAnotherCertificate:"Generate Another Certificate",
  pleaseWait: "Please wait...",
  loginPageTitle: "Login or sign up",
  verifyMobileNumberPageTitle:  "Verify mobile number",
  verifyEmailIdPageTitle: "Verify email ID",
  needMoreInformation: "Let’s get to know you better",
  mobileNumberAlreadySignUp: "This mobile number has already been used to sign up",
  emailIdAlreadySignUp: "This email ID has already been used to sign up",
  loginEmailIdMobileNoTitle: "Enter Email ID / Mobile Number",
  requestOtp: "Request OTP",
  changeMobileNumberText: "Change mobile number",
  changeEmailIdText: "Change email ID",
  verifyMobileNumberTitle: "We’ve sent the OTP to the registered mobile number",
  verifyEmailIdTitle: "We’ve sent the OTP to the registered email ID",
  incorrectOtpEnteredMessage: "Incorrect OTP entered",
  resendOtpMessage: "Resend OTP in {} seconds",
  cantSignIn: "Can’t sign in?",
  googleAccountInformationText: "We’ve got the above information from your Google account",
  countryOptional: "Country of Residence (optional)",
  moreSignIn: "More sign-in options",
  welcomeAboardTitle: "Welcome aboard,",
  welcomeAboardSubtitle: "You are now signed in",
  preferMobileNumber: "I prefer to sign in using my mobile number",
  preferEmail: "I prefer to sign in using my email",
  pleaseEnterOtp: "Please enter the OTP sent to",
  replaceGoogleAccount: "Would you like to link your google account with {}? You can then login with either your email ID or your Google account.",
  replaceEmailId: "Would you like to link the email ID {} to this account? You can then login with either your email ID or mobile number.",
  replaceMobileNumber: "Would you like to link the mobile number {} to this account? You can then login with either your email ID or mobile number.",
  cashNotAllowed: "Please connect with our 24x7 Akasa Care Centre to get the refund details of this booking",
  gClassBookingMsg: "Since your ticket is part of a group booking, please enter your First Name to Manage",
  enterFirstAndLastNameMsg: "Please enter the passenger’s First Name and Last Name as mentioned on the ticket",
  enterFirstNameMsg: "Please enter your First Name as mentioned on the ticket",
  addPassengers:"Add Passengers",
  checkInGroupBookingMsg: "Since your ticket is part of a group booking, please enter your First Name to check-in",
  enterValidatePaxName: "Please enter your First Name as mentioned on the ticket",
  bookingNotconfirmed: "Booking status is not confirmed",
  addPaxDetails: "Please add passenger details for check-in",
  checkIsNotAllowed: "check-in is not allow",
  alreadycheckIn: "Passenger already checked-in",
  checkInSummaryPiMsg: "All Booking related communication will be sent to {} and {}",
  checkInSuccessfullPiMsg: "Your Boarding pass(s) will be mailed to {}. Please click on send to another ID to send the boarding pass to a different ID",
  voucherPassengerNotFoundMessage: "The passenger’s name must match the name on the voucher",
  voucherAlreadyUsedForSamePNRError: "A voucher can only be redeemed once per booking reference.",
  unAppliedVoucherWarning: "Please apply or remove the voucher to proceed.",
  maxVoucherExceededForGroup: "This voucher cannot be used for group bookings.",
  maxVoucherExceeded: "You have already applied the maximum number of voucher codes permitted for this transaction.",
  noBalanceDueForPAX: "This voucher amount can only be used by the voucher owner",
  voucherExpiredMessage: "This voucher has expired and cannot be used further.",
  voucherHasNoBalance: "This voucher has no balance amount.",
  invalidVoucherCode: "The voucher code entered is invalid. Please use a valid code and try again.",
  voucherAlreadyAppliedMessage: "This voucher code has already been applied to this transaction",
  mandatoryErrorMessage: "Please fill all mandatory fields",
  selectDateOfBirthErrorMessage: "Select DOB",
  selectGenderErrorMessage: "Select Gender",
  selectTermsAndCondition: "Select Terms and Condition",
};

export const ALTTAGS = {
  image: "Image",
  icon: "Icon",
  playStoreIcon: "Play Store Icon",
  appStoreIcon: "App Store Icon",
  qrCode: "QR Code",
  mobilePhoneImg: "Mobile Phone Image",
  successLogo: "Success Logo",
  akasaAirLogo: "Akasa Air Logo",
  adImage: "Ad Image",
  iconOrImage: "Icon/Image"
};
